import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavbarDashboard = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="custom-navbar-container">
      <div className="custom-navbar-content">
        <div className="custom-navbar-links">
          <Link
            to="/admin/dashboard"
            className={`custom-navbar-link ${isActive("/admin/dashboard") ? "active" : ""}`}
          >
            Project Management
          </Link>
          <Link
            to="/admin/manage-strategic"
            className={`custom-navbar-link ${isActive("/admin/manage-strategic") ? "active" : ""}`}
          >
            Strategic Management
          </Link>
          <Link
            to="/admin/manage-operations"
            className={`custom-navbar-link ${isActive("/admin/manage-operations") ? "active" : ""}`}
          >
            Operation Management
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavbarDashboard;
